import { ApiQuery, ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Req, Query} from '@nestjs/common';
import { StatesService } from './states.service';
import { StatesDTO, StateStatusDTO } from './dto/states.dto';
import { StatesResponseModel, StatesStatusWiseResponseModel } from './dto/states-response.model';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { AllStatesResponseModel } from './dto/all-states-response.model';
import { StateIdRequest, StateNameRequest } from './dto/statename.request';

@ApiTags('States')
@Controller('states')
export class StatesController {
  constructor(
    private stateService: StatesService
  ){}

  @Post('/createState')
  @ApiQuery({name:'apiVersion'})
  async createState(@Query() queryParams, @Body() statesDto:StatesDTO,isUpdate:boolean=false,@Req() request:Request): Promise<StatesResponseModel> {
    try {
      return await this.stateService.createState(queryParams,statesDto, false,request);
    } catch (error) {
      return errorHandler(StatesResponseModel, error);
    }
  }
  

   /**
   * updates a state
   * @param companyDto which passes the details to be updated.
   * @returns Response  which returns the saved data along with status (true/false), errortype, intlcode, internal message which provides message the calling function.
   */
  @Post('/updateState')
  @ApiQuery({name:'apiVersion'})
  async updateState(@Query() queryParams,@Body() statesDto: StatesDTO,@Req() request:Request): Promise<StatesResponseModel> {
    try {
      return await this.stateService.createState(queryParams,statesDto, true,request);
    } catch (error) {
      return errorHandler(StatesResponseModel, error);
    }
  }

  @Post('/getAllStates')
  @ApiQuery({name:'apiVersion'})
  async getAllStates(@Query() queryParams, @Req() request: Request): Promise<AllStatesResponseModel> {
    try {
      return await this.stateService.getAllStates(queryParams, request);
    } catch (error) {
      return errorHandler(AllStatesResponseModel, error);
    }
  }
  
  @Post('/getStateByStateName')
  @ApiQuery({name:'apiVersion'})
  async getStateByStateName(@Query() queryParams, @Body() stateNameRequest: StateNameRequest, @Req() request:Request): Promise<StatesResponseModel> {
    try {
      return await this.stateService.getStateByStateName(queryParams,stateNameRequest.stateName,request);
    } catch (error) {
      return errorHandler(StatesResponseModel, error);
    }
  }

  @Post('/getStateByStateId')
  @ApiQuery({name:'apiVersion'})
  async getStateByStateId(@Query() queryParams, @Body() stateIdRequest: StateIdRequest, @Req() request:Request): Promise<StatesResponseModel> {
    try {
      return await this.stateService.getStateByStateId(queryParams,stateIdRequest.stateId,request);
    } catch (error) {
      return errorHandler(StatesResponseModel, error);
    }
  }

  @Post('/getAllActiveStates')
  @ApiQuery({name:'apiVersion'})
  async getAllActiveStates(@Query() queryParams, @Req() request:Request): Promise<AllStatesResponseModel> {
    try {
      return await this.stateService.getAllActiveStates(queryParams,request);
    } catch (error) {
      return errorHandler(AllStatesResponseModel, error);
    }
  }

  @Post('/getActiveStatesCount')
  @ApiQuery({name:'apiVersion'})
  async getActiveStatesCount(@Query() queryParams, @Req() request:Request): Promise<StatesStatusWiseResponseModel> {
    try {
      return await this.stateService.getActiveStatesCount(queryParams, request);
    } catch (error) {
      return errorHandler(StatesStatusWiseResponseModel, error);
    }
  }

  @Post('/updateStateStatus')
  @ApiQuery({name:'apiVersion'})
  async updateStateStatus(@Query() queryParams, @Body() stateStatusDto:StateStatusDTO ,@Req() request:Request): Promise<StatesResponseModel> {
    try {
      return await this.stateService.updateStateStatus(queryParams,stateStatusDto, request);
    } catch (error) {
      return errorHandler(StatesResponseModel, error);
    }
  }
}
